/**
 * @file コンポーネント：フル動画ページタイムラインアイテム スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledItem = styled.div``;

export const StyledItemButton = styled.button`
    width: 100%;
    padding: 8px 16px;
    border: none;
    background-color: transparent;
    text-align: left;

    &.is-active {
        background-color: #343a40;
    }

    &.is-dummy-disabled {
        cursor: default;
    }
`;

export const StyledItemEditContainer = styled.div`
    padding: 8px 16px;
`;

export const StyledItemEditlist = styled.ul`
    display: flex;
    justify-content: flex-end;
`;

export const StyledItemEditlistItem = styled.li`
    margin-right: 8px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledItemEditlistItemLink = styled.a`
    color: #eed393;
    font-size: 11px;

    &.is-disabled {
        color: #acadae;
        pointer-events: none;
    }
`;

export const StyledItemEditlistItemLinkIcon = styled.span`
    margin-right: 4px;
`;

export const StyledItemEditlistItemLinkText = styled.span``;

export const StyledItemEditText = styled.p`
    margin-bottom: 8px;
    color: #ffffff;
    text-align: right;
`;

export const StyledItemText = styled.span`
    display: block;
    color: #ffffff;
    font-size: 11px;
    line-height: 16px;
`;

export const StyledItemTime = styled.span`
    display: block;
    margin-bottom: 8px;
    color: #7f97f8;
    font-weight: bold;
    font-size: 11px;
    line-height: 16px;
`;
